module.exports = __webpack_public_path__ + "static/media/que-hacer-en-recoleta.a2c3f8ad.md";